// Brand assets uploaded by user
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/artifacts/qifa4b19_ec19ff29-919d-4133-a950-85d0f4989e02.png";

const IMG_FRIEDRICE =
  "https://customer-assets.emergentagent.com/job_f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/artifacts/yxlcaq0n_IMG_5522.jpg";
const IMG_STEAK =
  "https://customer-assets.emergentagent.com/job_f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/artifacts/hd0bwt96_IMG_5524.jpg";
const IMG_SKEWERS =
  "https://customer-assets.emergentagent.com/job_cute-bites-1/artifacts/u6cksj5u_IMG_5526.jpg";
const IMG_PHO =
  "https://customer-assets.emergentagent.com/job_cute-bites-1/artifacts/s8akvshm_IMG_5527.jpg";

const SHOP_EBOOK = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/4363ab6d4600eb1226f1c808c026ec576c51f8884c047a74b12fc0967296e4ee.png";
const TEE_CORAL = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/c6766610a3d8db7b5ddae49c7ac70050d80bc4a3696051e00fe95aebf76d9f3a.png";
const TEE_SAGE = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/a84612a9940c792e28a01e31d00bca10ed6385048a2b3f0f537c1d19e65c42ac.png";
const TEE_MUSTARD = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/900fb5c897720e80e3fcad344cf64b814910de2fb3b4d2c3c37ed660296f8844.png";
const HAT_BEIGE = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/f084a5db48f45b5d0101bc2abd96973635e28c2b331fcfa7848a715406207275.png";
const HAT_SAGE = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/38031a10fe828e633b22cd094030d3263ff8e4d32b2bf5fa995df9fb168b3689.png";
const HAT_CORAL = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/d76ede739f4206314eac75114cd24138456e1ea387c157d03037ba50ff485e0f.png";
const SHOP_BOOKMARKS = "https://static.prod-images.emergentagent.com/jobs/f8d815f3-c54c-4cdc-a654-d0ef9e9e7398/images/4403c20352dbbcd81a74135cd26800861889d35f06ee4fdb72c43b148ffd4c4c.png";

export const t = {
  nav_recipes: { en: "Recipes", vi: "Công thức" },
  nav_about: { en: "About", vi: "Về tụi mình" },
  hero_title: { en: "Eat well, live well.", vi: "Ăn ngon, sống khỏe." },
  hero_sub: {
    en: "A small kitchen diary of cozy, balanced meal prep recipes. Real food, made simple.",
    vi: "Cuốn nhật ký bếp nhỏ với những công thức meal prep cân bằng. Nguyên liệu thật, làm đơn giản.",
  },
  hero_cta: { en: "View recipes", vi: "Xem công thức" },
  recipes_title: { en: "Recipes", vi: "Công thức" },
  view_recipe: { en: "View", vi: "Xem" },
  search_ph: { en: "Search a dish...", vi: "Tìm món..." },
  filter_all: { en: "Everything", vi: "Tất cả" },
  filter_loved: { en: "Loved", vi: "Yêu thích" },
  no_results: { en: "Hmm, nothing here yet. Try another search!", vi: "Chưa có gì cả. Thử tìm món khác nhé!" },
  ingredients: { en: "Ingredients", vi: "Nguyên liệu" },
  steps: { en: "Method", vi: "Cách làm" },
  minutes: { en: "min", vi: "phút" },
  serves: { en: "serves", vi: "phần" },
  nutrition_title: { en: "Per serving", vi: "Mỗi phần" },
  kcal: { en: "kcal", vi: "kcal" },
  servings_label: { en: "Make it for", vi: "Nấu cho" },
  print_btn: { en: "Print", vi: "In" },
  share_btn: { en: "Share", vi: "Chia sẻ" },
  share_done: { en: "Link copied — go share the love!", vi: "Đã chép link — chia sẻ nha!" },
  grocery_btn: { en: "Grocery list", vi: "Đi chợ" },
  fav_added: { en: "Saved to your favorites!", vi: "Đã lưu vào yêu thích!" },
  fav_removed: { en: "Okay, removed that one.", vi: "Đã bỏ khỏi yêu thích." },
  about_title: { en: "About", vi: "Về tụi mình" },
  about_p1: {
    en: "It all began with one cozy kitchen and a little cabbage with big dreams. Ăn Khỏe Project is our happy place for generous, balanced meal preps. Real food, made simple, and always served with a smile. Come hang out and eat well with us!",
    vi: "Tất cả bắt đầu từ một căn bếp ấm cúng và một bạn bắp cải nhỏ với ước mơ lớn. Ăn Khỏe Project là chốn vui của tụi mình với những phần meal prep cân bằng, rộng rãi. Đồ ăn thật, làm đơn giản, và luôn kèm một nụ cười. Ghé chơi và ăn khỏe cùng tụi mình nha!",
  },
  about_sign: { en: "Cabbage, Head of Kitchen", vi: "Bắp Cải, Bếp trưởng" },
  video_kicker: { en: "Watch", vi: "Xem" },
  video_title: { en: "Straight from our kitchen", vi: "Ngay tại bếp của tụi mình" },
  video_sub: {
    en: "A little peek at how we cook, plate and prep. Press play.",
    vi: "Một thoáng nhìn cách tụi mình nấu, bày và chuẩn bị. Bấm xem nha.",
  },
  footer_tag: { en: "A cozy kitchen diary of healthy, balanced meal prep recipes. Real food, made simple.", vi: "Cuốn nhật ký bếp ấm cúng với những công thức meal prep lành mạnh, cân bằng. Đồ ăn thật, làm đơn giản." },
  footer_explore: { en: "Explore", vi: "Khám phá" },
  footer_follow: { en: "Follow", vi: "Theo dõi" },
  footer_top: { en: "Back to top", vi: "Lên đầu trang" },
  footer_made: { en: "Made in a home kitchen", vi: "Làm tại bếp nhà" },
  shop_kicker: { en: "Shop", vi: "Cửa hàng" },
  shop_title: { en: "Take a little home", vi: "Mang một chút về nhà" },
  shop_sub: {
    en: "Cute kitchen goods, made with the same love as our food.",
    vi: "Đồ bếp dễ thương, làm bằng tình yêu như món ăn của tụi mình.",
  },
  shop_buy: { en: "Buy now", vi: "Mua ngay" },
  shop_loading: { en: "One sec...", vi: "Chờ chút..." },
  shop_error: { en: "Oops, that didn't go through. Mind trying again?", vi: "Ơ, chưa được. Thử lại giúp nha?" },
  pay_success: { en: "Yay! Your order's in — thank you so much! 🌿", vi: "Yay! Đơn hàng đã nhận — cảm ơn bạn nhiều! 🌿" },
  pay_cancel: { en: "No worries, your order was cancelled.", vi: "Không sao, đơn hàng đã được hủy." },
  macro_kicker: { en: "Macros", vi: "Macro" },
  macro_title: { en: "Quick macro estimate", vi: "Ước tính macro nhanh" },
  macro_sub: { en: "Answer a few questions for a rough daily target.", vi: "Trả lời vài câu hỏi để có mục tiêu mỗi ngày." },
  macro_weight: { en: "Weight (kg)", vi: "Cân nặng (kg)" },
  macro_height: { en: "Height (cm)", vi: "Chiều cao (cm)" },
  macro_age: { en: "Age", vi: "Tuổi" },
  macro_sex: { en: "Sex", vi: "Giới tính" },
  macro_male: { en: "Male", vi: "Nam" },
  macro_female: { en: "Female", vi: "Nữ" },
  macro_activity: { en: "Activity", vi: "Vận động" },
  act_sedentary: { en: "Sedentary", vi: "Ít vận động" },
  act_light: { en: "Lightly active", vi: "Vận động nhẹ" },
  act_moderate: { en: "Moderately active", vi: "Vận động vừa" },
  act_active: { en: "Very active", vi: "Vận động nhiều" },
  macro_goal: { en: "Goal", vi: "Mục tiêu" },
  goal_lose: { en: "Lose weight", vi: "Giảm cân" },
  goal_maintain: { en: "Maintain", vi: "Giữ cân" },
  goal_gain: { en: "Gain weight", vi: "Tăng cân" },
  macro_calc: { en: "Calculate", vi: "Tính ngay" },
  macro_calories: { en: "Calories / day", vi: "Calo / ngày" },
  macro_protein: { en: "Protein", vi: "Đạm" },
  macro_carbs: { en: "Carbs", vi: "Tinh bột" },
  macro_fat: { en: "Fat", vi: "Chất béo" },
  macro_disclaimer: {
    en: "Friendly estimate only. This is not medical advice. Talk to a professional for personal guidance.",
    vi: "Chỉ là ước tính thân thiện. Đây không phải lời khuyên y tế. Hãy hỏi chuyên gia để được tư vấn riêng.",
  },
  testi_kicker: { en: "Kind words", vi: "Lời khen" },
  testi_title: { en: "From our little kitchen community", vi: "Từ cộng đồng bếp nhỏ" },
  news_title: { en: "Let's keep in touch", vi: "Giữ liên lạc nhé" },
  news_sub: {
    en: "One cozy recipe in your inbox now and then. No spam, pinky promise.",
    vi: "Thỉnh thoảng một công thức ấm áp vào hộp thư. Không spam, hứa đó.",
  },
  news_ph: { en: "you@email.com", vi: "email@cua-ban.com" },
  news_btn: { en: "Count me in", vi: "Đăng ký liền" },
  news_done: { en: "You're in! Talk soon 🌿", vi: "Xong rồi! Hẹn gặp lại 🌿" },
  news_error: { en: "That email looks off — mind checking it?", vi: "Email có vẻ sai — kiểm tra giúp nha?" },
  give_kicker: { en: "Give back", vi: "Cho đi" },
  give_title: { en: "Eat well, give well", vi: "Ăn khỏe, cho đi" },
  give_sub: {
    en: "A few food focused charities we admire. Every little gift helps someone eat today.",
    vi: "Vài tổ chức thiện nguyện về thực phẩm mà tụi mình quý mến. Mỗi đóng góp nhỏ giúp ai đó có bữa ăn hôm nay.",
  },
  give_btn: { en: "Donate", vi: "Quyên góp" },
  give_disclaimer: {
    en: "We are not affiliated with these organizations and receive nothing from your gifts. Donations go straight to each charity through their own secure pages.",
    vi: "Tụi mình không liên kết với các tổ chức này và không nhận bất kỳ khoản nào từ đóng góp của bạn. Tiền quyên góp đi thẳng đến từng tổ chức qua trang an toàn của họ.",
  },
  nav_give: { en: "Give", vi: "Cho đi" },
  nav_careers: { en: "Careers", vi: "Tuyển dụng" },
  career_kicker: { en: "Join us", vi: "Gia nhập" },
  career_title: { en: "Cook up a career with us", vi: "Cùng tụi mình dựng sự nghiệp" },
  career_sub: {
    en: "We are a tiny, cozy kitchen studio always looking for warm, curious people who love good food.",
    vi: "Tụi mình là một studio bếp nhỏ ấm cúng, luôn tìm những người ấm áp, tò mò và mê đồ ăn ngon.",
  },
  career_type: { en: "Type", vi: "Hình thức" },
  career_loc: { en: "Location", vi: "Địa điểm" },
  career_apply: { en: "Apply", vi: "Ứng tuyển" },
  career_empty_note: {
    en: "Do not see the right fit? Say hello anyway. We love meeting kitchen people.",
    vi: "Chưa thấy vị trí hợp? Cứ chào tụi mình nhé. Tụi mình luôn vui khi gặp người mê bếp.",
  },
  career_open_apps: { en: "Send an open application", vi: "Gửi hồ sơ tự do" },
};

export const recipes = [
  {
    id: "shrimp-fried-rice",
    image: IMG_FRIEDRICE,
    minutes: 30,
    serves: 4,
    category: { en: "Meal prep", vi: "Meal prep" },
    nutrition: { kcal: 420, protein: 28, carbs: 45, fat: 14 },
    title: { en: "Sea & Smoke Fried Rice", vi: "Cơm Chiên Biển & Khói" },
    blurb: {
      en: "Smoky shrimp, savory beef and crisp carrots through fluffy day old rice.",
      vi: "Tôm thơm, bò đậm vị và cà rốt giòn trộn cùng cơm nguội tơi.",
    },
    ingredients: {
      en: ["3 cups cooked day old rice", "200g shrimp, peeled", "150g ground beef", "2 eggs, beaten", "1 carrot, diced", "1/2 onion, diced", "3 tbsp soy sauce", "1 tsp sesame oil"],
      vi: ["3 chén cơm nguội", "200g tôm đã lột", "150g thịt bò xay", "2 quả trứng đánh tan", "1 củ cà rốt thái hạt lựu", "1/2 củ hành tây", "3 thìa nước tương", "1 thìa dầu mè"],
    },
    steps: {
      en: ["Sear shrimp until pink, set aside.", "Brown the beef with onion and carrot.", "Push aside, scramble the eggs.", "Add rice, soy sauce and sesame oil; toss on high heat.", "Fold shrimp back in and serve."],
      vi: ["Áp chảo tôm đến khi hồng, để riêng.", "Xào thịt bò với hành tây và cà rốt.", "Gạt sang một bên, chiên trứng.", "Cho cơm, nước tương, dầu mè vào đảo lửa lớn.", "Cho tôm vào lại và dọn ra."],
    },
  },
  {
    id: "garlic-butter-ribeye",
    image: IMG_STEAK,
    minutes: 20,
    serves: 2,
    category: { en: "Beef", vi: "Thịt bò" },
    nutrition: { kcal: 540, protein: 42, carbs: 2, fat: 40 },
    title: { en: "Midnight Garlic Ribeye", vi: "Ribeye Bơ Tỏi Đêm Khuya" },
    blurb: {
      en: "A juicy, peppery ribeye basted in garlic butter and sliced to perfection.",
      vi: "Miếng ribeye mọng nước, đậm tiêu, rưới bơ tỏi và thái mỏng hoàn hảo.",
    },
    ingredients: {
      en: ["1 ribeye steak (300g)", "3 cloves garlic", "2 tbsp butter", "1 tbsp olive oil", "Coarse black pepper", "Flaky sea salt", "Sprig of thyme"],
      vi: ["1 miếng ribeye (300g)", "3 tép tỏi", "2 thìa bơ", "1 thìa dầu ô liu", "Tiêu đen xay thô", "Muối biển", "Vài nhánh húng tây"],
    },
    steps: {
      en: ["Pat steak dry, season generously.", "Sear in hot oil 3 min each side.", "Add butter, garlic and thyme; baste continuously.", "Rest 5 minutes, then slice against the grain.", "Spoon over the garlic butter and enjoy."],
      vi: ["Thấm khô thịt, nêm đậm.", "Áp chảo dầu nóng 3 phút mỗi mặt.", "Cho bơ, tỏi, húng tây; rưới liên tục.", "Để nghỉ 5 phút rồi thái ngang thớ.", "Rưới bơ tỏi lên và thưởng thức."],
    },
  },
  {
    id: "chicken-veggie-skewers",
    image: IMG_SKEWERS,
    minutes: 35,
    serves: 4,
    category: { en: "Chicken", vi: "Thịt gà" },
    nutrition: { kcal: 310, protein: 35, carbs: 12, fat: 13 },
    title: { en: "Garden Party Skewers", vi: "Xiên Tiệc Vườn" },
    blurb: {
      en: "Tender herbed chicken threaded with zucchini, peppers and red onion. Colorful and light.",
      vi: "Gà ướp thảo mộc mềm thơm xiên cùng bí ngòi, ớt chuông và hành tím. Đầy màu sắc và nhẹ nhàng.",
    },
    ingredients: {
      en: ["500g chicken breast, cubed", "1 zucchini, sliced", "1 red bell pepper", "1 red onion, wedged", "2 tbsp olive oil", "1 tsp dried oregano", "2 cloves garlic, minced", "Salt & pepper"],
      vi: ["500g ức gà thái khối", "1 quả bí ngòi cắt lát", "1 quả ớt chuông đỏ", "1 củ hành tím bổ múi", "2 thìa dầu ô liu", "1 thìa oregano khô", "2 tép tỏi băm", "Muối & tiêu"],
    },
    steps: {
      en: ["Toss chicken with oil, garlic, oregano, salt and pepper.", "Marinate 20 minutes.", "Thread chicken and veggies onto skewers.", "Grill or roast at 200°C, turning, for 18 to 20 min.", "Rest a few minutes and serve."],
      vi: ["Trộn gà với dầu, tỏi, oregano, muối và tiêu.", "Ướp 20 phút.", "Xiên gà và rau củ lên que.", "Nướng ở 200°C, trở đều, 18 đến 20 phút.", "Để nghỉ vài phút rồi dọn ra."],
    },
  },
  {
    id: "beef-pho",
    image: IMG_PHO,
    minutes: 90,
    serves: 4,
    category: { en: "Soup", vi: "Món nước" },
    nutrition: { kcal: 480, protein: 38, carbs: 50, fat: 12 },
    title: { en: "Grandma's Beef Phở", vi: "Phở Bò Của Bà" },
    blurb: {
      en: "A clear, fragrant beef broth with tender slices, beef balls, bean sprouts and scallions.",
      vi: "Nước dùng bò trong và thơm với thịt bò mềm, bò viên, giá đỗ và hành lá.",
    },
    ingredients: {
      en: ["1.5kg beef bones", "300g beef brisket", "200g beef balls", "1 onion, charred", "1 thumb ginger, charred", "Star anise, cinnamon, cloves", "Bean sprouts & scallions", "Fish sauce, salt"],
      vi: ["1.5kg xương bò", "300g nạm bò", "200g bò viên", "1 củ hành tây nướng", "1 nhánh gừng nướng", "Hoa hồi, quế, đinh hương", "Giá đỗ & hành lá", "Nước mắm, muối"],
    },
    steps: {
      en: ["Parboil bones, rinse, then simmer with charred onion and ginger.", "Add toasted spices and simmer 1.5 hours.", "Season broth with fish sauce and salt.", "Cook brisket and beef balls until tender.", "Ladle broth over slices, top with sprouts and scallions."],
      vi: ["Trụng xương, rửa sạch rồi ninh với hành và gừng nướng.", "Cho gia vị đã rang vào ninh 1.5 giờ.", "Nêm nước dùng với nước mắm và muối.", "Luộc nạm và bò viên đến khi mềm.", "Chan nước lên thịt, thêm giá và hành lá."],
    },
  },
];

export const products = [
  {
    id: "ebook",
    image: SHOP_EBOOK,
    price: "$59",
    tag: { en: "Digital", vi: "Kỹ thuật số" },
    name: { en: "The Ăn Khỏe Cookbook", vi: "Sách nấu ăn Ăn Khỏe" },
    desc: { en: "30 cozy meal prep recipes in a beautiful PDF.", vi: "30 công thức meal prep ấm cúng trong bản PDF đẹp." },
  },
  {
    id: "shirt",
    image: TEE_CORAL,
    price: "$88",
    tag: { en: "Apparel", vi: "Trang phục" },
    name: { en: "Cabbage Club Tee", vi: "Áo thun Cabbage Club" },
    desc: { en: "Soft organic cotton, pick your color.", vi: "Cotton hữu cơ mềm, chọn màu bạn thích." },
    variants: [
      { hex: "#C66B4E", image: TEE_CORAL },
      { hex: "#8FA888", image: TEE_SAGE },
      { hex: "#E6B23E", image: TEE_MUSTARD },
    ],
  },
  {
    id: "hat",
    image: HAT_BEIGE,
    price: "$72",
    tag: { en: "Apparel", vi: "Trang phục" },
    name: { en: "Home Kitchen Cap", vi: "Nón Home Kitchen" },
    desc: { en: "Embroidered logo, pick your color.", vi: "Logo thêu, chọn màu bạn thích." },
    variants: [
      { hex: "#D9CBB0", image: HAT_BEIGE },
      { hex: "#8FA888", image: HAT_SAGE },
      { hex: "#C66B4E", image: HAT_CORAL },
    ],
  },
  {
    id: "bookmarks",
    image: SHOP_BOOKMARKS,
    price: "$34",
    tag: { en: "Paper goods", vi: "Đồ giấy" },
    name: { en: "Cabbage Bookmark Set", vi: "Bộ Đánh Dấu Sách Cabbage" },
    desc: { en: "Set of three cute bookmarks with tassels.", vi: "Bộ ba đánh dấu sách dễ thương kèm tua rua." },
  },
];

export const testimonials = [
  {
    name: "Mai",
    place: { en: "Sunday meal-prepper", vi: "Người mê meal-prep" },
    text: {
      en: "I batch cook every Sunday with these now. My fridge has honestly never looked this good — or this organized.",
      vi: "Giờ Chủ nhật nào mình cũng nấu sẵn theo mấy công thức này. Tủ lạnh chưa bao giờ gọn và đẹp đến thế.",
    },
  },
  {
    name: "James",
    place: { en: "Phở convert", vi: "Fan của phở" },
    text: {
      en: "The phở tasted just like my favorite spot back home. I didn't think I could pull it off — turns out I could.",
      vi: "Phở nấu ra y như quán ruột ở nhà. Mình tưởng không làm nổi, ai ngờ làm được luôn.",
    },
  },
  {
    name: "Linh",
    place: { en: "Busy mom of three", vi: "Mẹ ba bé bận rộn" },
    text: {
      en: "Finally, healthy food the whole family actually fights over. The kids ask for the skewers by name now!",
      vi: "Cuối cùng cũng có món lành mạnh mà cả nhà tranh nhau ăn. Tụi nhỏ giờ đòi món xiên suốt!",
    },
  },
];


export const charities = [
  {
    id: "wck",
    name: "World Central Kitchen",
    url: "https://wck.org/donate",
    accent: "#C66B4E",
    focus: { en: "Global relief", vi: "Cứu trợ toàn cầu" },
    blurb: {
      en: "Fresh meals for communities facing crisis and disaster around the world.",
      vi: "Bữa ăn nóng cho các cộng đồng gặp khủng hoảng và thiên tai trên khắp thế giới.",
    },
  },
  {
    id: "feeding-america",
    name: "Feeding America",
    url: "https://www.feedingamerica.org/",
    accent: "#6F7F63",
    focus: { en: "US food banks", vi: "Ngân hàng thực phẩm Mỹ" },
    blurb: {
      en: "A nationwide network of food banks fighting hunger across the United States.",
      vi: "Mạng lưới ngân hàng thực phẩm toàn quốc chống nạn đói trên khắp nước Mỹ.",
    },
  },
  {
    id: "food-bank-vietnam",
    name: "Food Bank Việt Nam",
    url: "https://foodbankvietnam.com/",
    accent: "#E6B23E",
    focus: { en: "Vietnam", vi: "Việt Nam" },
    blurb: {
      en: "Rescuing surplus food and sharing warm meals with people in need in Vietnam.",
      vi: "Cứu trợ thực phẩm dư thừa và chia sẻ bữa ăn ấm cho người khó khăn tại Việt Nam.",
    },
  },
  {
    id: "the-hunger-project",
    name: "The Hunger Project",
    url: "https://thp.org/",
    accent: "#8FA888",
    focus: { en: "Community development", vi: "Phát triển cộng đồng" },
    blurb: {
      en: "Empowering local communities with lasting, self reliant solutions to hunger.",
      vi: "Trao quyền cho cộng đồng địa phương với giải pháp bền vững, tự chủ trước nạn đói.",
    },
  },
];

export const CAREERS_EMAIL = "hello@ankhoeproject.com";

export const careers = [
  {
    id: "recipe-developer",
    accent: "#C66B4E",
    title: { en: "Recipe Developer", vi: "Phát triển công thức" },
    type: { en: "Full time", vi: "Toàn thời gian" },
    location: { en: "Remote / Hybrid", vi: "Từ xa / Linh hoạt" },
    blurb: {
      en: "Dream up, test and write cozy meal prep recipes that taste as good as they look.",
      vi: "Sáng tạo, thử nghiệm và viết những công thức meal prep ấm cúng, ngon như khi nhìn.",
    },
  },
  {
    id: "content-intern",
    accent: "#6F7F63",
    title: { en: "Content Intern", vi: "Thực tập Nội dung" },
    type: { en: "Internship", vi: "Thực tập" },
    location: { en: "Remote", vi: "Từ xa" },
    blurb: {
      en: "Help shoot, edit and caption short kitchen videos and photos for our channels.",
      vi: "Cùng quay, dựng và viết chú thích cho video, hình ảnh bếp ngắn trên các kênh.",
    },
  },
  {
    id: "community-intern",
    accent: "#E6B23E",
    title: { en: "Community Intern", vi: "Thực tập Cộng đồng" },
    type: { en: "Internship", vi: "Thực tập" },
    location: { en: "Remote", vi: "Từ xa" },
    blurb: {
      en: "Reply to our lovely readers, gather ideas and keep our little community warm.",
      vi: "Trả lời độc giả đáng yêu, thu thập ý tưởng và giữ cộng đồng nhỏ luôn ấm áp.",
    },
  },
];

